import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";
import type { MapReadyState } from "../types";

/** Default map readiness state. */
export const MAP_READY_DEFAULT: MapReadyState = { "isMapReady": false };

/** Whether the MapLibre instance has finished loading. */
export const mapReadySlice = defineEphemeralSlice<MapReadyState>( {
    "key":     "mapReady",
    "default": () => MAP_READY_DEFAULT,
} );
